import {DrawerItemData} from "../../app/types";
import {BotsControlContent} from "./BotsControlContent";
import {BotsControlDrawerItem} from "./BotsControlDrawerItem";

export const BotsControlComponent: DrawerItemData = {
    uid: "bots",
    drawerItem: BotsControlDrawerItem,
    content: BotsControlContent
};
